import React from 'react';
import classNames from 'classnames';

import {MenuContext} from '../menu_context';

import './menu_item.scss';
import {hideMenu} from 'components/widgets/context-menu';

const hoverDisabledStyle = {
    pointerEvents: 'none',
};

const defaultStyle = {};

export default function menuItem(Component: React.ComponentType<any>) {
    type Props = {
        show: boolean;
        id?: string;
        icon?: React.ReactNode;
        text?: React.ReactNode;
        extraText?: string;
        hoverDisabled?: boolean;
        dataQa?: string;
        preventClose?: boolean;
        onClick?: (e: React.MouseEvent) => void;
        isDangerous?: boolean;
    };
    class MenuItem extends React.PureComponent<Props & React.ComponentProps<typeof Component>> {
        declare context: React.ContextType<typeof MenuContext>

        public static defaultProps = {
            show: true,
        };

        handleClick = (e: React.MouseEvent) => {
            const {onClick, preventClose} = this.props;
            onClick?.(e);
            if (!preventClose) {
                hideMenu();
            }
        }

        public static displayName?: string;

        public static contextType = MenuContext;

        hideSubmenuItem = () => this.context.onCloseSubMenuItem();

        public render() {
            const {id, show, icon, text, extraText, rightDecorator, ...props} = this.props;
            if (!show) {
                return null;
            }

            const content = (
                <>
                    <div className='MenuItem__content'>
                        {icon && (
                            <div
                                className={classNames('MenuItem__icon-container')}
                            >
                                {icon}
                            </div>
                        )}
                        {text && (
                            <div className='MenuItem__text'>
                                <div className='MenuItem__primary-text'>{text}</div>
                                {extraText && <span className='MenuItem__help-text'>{extraText}</span>}
                            </div>
                        )}
                        {rightDecorator &&
                        <div
                            className={classNames(
                                'MenuItem__right-decorator',
                                {'MenuItem__right-decorator-text': typeof rightDecorator === 'string'},
                            )}
                        >
                            {rightDecorator}
                        </div>}
                    </div>
                </>
            );

            return (
                <li
                    className={classNames('MenuItem', {
                        'MenuItem--with-icon': icon,
                        MenuItem__dangerous: this.props.isDangerous,
                    })}
                    style={this.props.hoverDisabled ? hoverDisabledStyle : defaultStyle}
                    role='menuitem'
                    id={id}
                    data-qa={this.props.dataQa}
                    onMouseEnter={this.hideSubmenuItem}
                >
                    <Component
                        content={content}
                        ariaLabel={text}
                        {...props}
                        onClick={this.handleClick}
                    />
                </li>
            );
        }
    }
    return MenuItem;
}
